<template>
  <div class="stats">
    <div class="today">Today</div>
    <div>Unique visits today: {{ countOfVisitorsToday }}</div>
    <div>Signed up today: {{ signedUpTodayCount }}</div>
    <div class="today">Week</div>
    <div>Signed up within last 7 days: {{ signedUpLastDaysCount(7) }}</div>
    <div>Sign up increase in last week: {{ signUpIncrease(14, 7, 7, 0) }}%</div>
    <div>
      Unique visits since last 7 days: {{ visitedSinceLastDaysCount(7) }}
    </div>
    <div class="today">2 weeks</div>
    <div>Signed up within last 14 days: {{ signedUpLastDaysCount(14) }}</div>
    <div>Signed up in that week: {{ signedUpInRange(14, 7) }}</div>
    <div>
      Sign up increase in that week: {{ signUpIncrease(21, 14, 14, 7) }}%
    </div>
    <div>
      Unique visits since last 14 days: {{ visitedSinceLastDaysCount(14) }}
    </div>
    <div class="today">3 weeks</div>
    <div>Signed up within last 21 days: {{ signedUpLastDaysCount(21) }}</div>
    <div>Signed up in that week: {{ signedUpInRange(21, 14) }}</div>
    <div>
      Sign up increase in that week: {{ signUpIncrease(28, 21, 21, 14) }}%
    </div>
    <div>
      Unique visits since last 21 days: {{ visitedSinceLastDaysCount(21) }}
    </div>
    <div class="today">4 weeks</div>
    <div>Signed up within last 28 days: {{ signedUpLastDaysCount(28) }}</div>
    <div>Signed up in that week: {{ signedUpInRange(28, 21) }}</div>
    <div>
      Unique visits since last 28 days: {{ visitedSinceLastDaysCount(28) }}
    </div>
  </div>
</template>

<script>
import { isToday } from "date-fns";

export default {
  name: "GeneralStats",
  props: {
    allUsers: Array,
  },
  computed: {
    signedUpTodayCount() {
      let count = 0;
      for (var i = 0; i < this.allUsers.length; i++) {
        let user = this.allUsers[i];
        if (isToday(new Date(user.createdAt))) {
          count++;
        }
      }
      return count;
    },
    countOfVisitorsToday() {
      let count = 0;
      for (var i = 0; i < this.allUsers.length; i++) {
        let user = this.allUsers[i];
        if (!user.lastAwardedBadgeCheckDate) {
          user.lastAwardedBadgeCheckDate = 0;
        }
        if (isToday(new Date(user.lastAwardedBadgeCheckDate))) {
          count++;
        }
      }
      return count;
    },
  },
  methods: {
    signedUpLastDaysCount(n) {
      let nowInMS = Date.now();
      let weekInMS = 24 * n * 60 * 60 * 1000;
      let weekAgo = nowInMS - weekInMS;
      let count = 0;
      for (var i = 0; i < this.allUsers.length; i++) {
        let user = this.allUsers[i];
        let userJoinDateInMS = new Date(user.createdAt).valueOf();
        if (userJoinDateInMS >= weekAgo) {
          count++;
        }
      }
      return count;
    },
    visitedSinceLastDaysCount(n) {
      let nowInMS = Date.now();
      let weekInMS = 24 * n * 60 * 60 * 1000;
      let weekAgo = nowInMS - weekInMS;
      let count = 0;
      for (var i = 0; i < this.allUsers.length; i++) {
        let user = this.allUsers[i];
        if (!user.lastAwardedBadgeCheckDate) {
          user.lastAwardedBadgeCheckDate = 0;
        }
        let userVisitInMS = new Date(user.lastAwardedBadgeCheckDate).valueOf();
        if (userVisitInMS >= weekAgo) {
          count++;
        }
      }
      return count;
    },
    signedUpInRange(startAgoDays, endAgoDays) {
      let nowInMS = Date.now();
      let startInMS = 24 * startAgoDays * 60 * 60 * 1000;
      let endInMS = 24 * endAgoDays * 60 * 60 * 1000;
      let startAgoInMS = nowInMS - startInMS;
      let endAgoInMS = nowInMS - endInMS;
      let count = 0;
      for (var i = 0; i < this.allUsers.length; i++) {
        let user = this.allUsers[i];
        let userJoinDateInMS = new Date(user.createdAt).valueOf();
        if (
          userJoinDateInMS >= startAgoInMS &&
          userJoinDateInMS <= endAgoInMS
        ) {
          count++;
        }
      }
      return count;
    },
    signUpIncrease(previousStart, previousEnd, newStart, newEnd) {
      let lastWeekNr = this.signedUpInRange(previousStart, previousEnd);
      let newWeekNr = this.signedUpInRange(newStart, newEnd);
      let increase = newWeekNr - lastWeekNr;
      let increasePercentage = (increase / lastWeekNr) * 100;
      return Math.round(increasePercentage);
    },
  },
};
</script>